// The viewer's chosen order for the Phase 5 ranked list, remembered in this
// browser. Storage can be blocked or unavailable: reading then gives the
// default order, and a choice still applies for the visit (it lives in the
// store too).
import type {TCandidateSort} from "api/polarisApi/types";

export const CANDIDATE_SORT_STORAGE_KEY = "polaris.rankedSort";

// Match % unless this browser remembers Best overall fit: people expect the
// ranked list in match order.
export const DEFAULT_CANDIDATE_SORT: TCandidateSort = "match";

export const readStoredCandidateSort = (): TCandidateSort => {
	try {
		return window.localStorage.getItem(CANDIDATE_SORT_STORAGE_KEY) === "best_fit"
			? "best_fit"
			: DEFAULT_CANDIDATE_SORT;
	} catch {
		return DEFAULT_CANDIDATE_SORT;
	}
};

export const storeCandidateSort = (sort: TCandidateSort) => {
	try {
		window.localStorage.setItem(CANDIDATE_SORT_STORAGE_KEY, sort);
	} catch {
		// Remembering is a convenience; the order still changes for this visit.
	}
};
